import AutoLoadingButton from "@/components/AutoLoadingButton";
import { CustomizationInfoType, SEOrderParsedCustomizationInfo } from "@/dto/order/CustomizationInfoDTO";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import { syncCustomizationInfoToSupplier } from "@/services/api/dropShipping/order";
import { message } from "antd";
import React, { useMemo } from "react";
import CustomizationInfo from "../../../column/CustomizationInfoColumn/CustomizationInfo";
import CustomizationInfoUnpaid from "../../../column/CustomizationInfoColumn/CustomizationInfoUnpaid";

interface CustomizationColumnV1Props {
    order: OrderDTO;

    orderItem: OrderItemDTO;

    isSupplierShop?: boolean;

    customizationInfos: SEOrderParsedCustomizationInfo[];
}

const CustomizationColumnV1: React.FC<CustomizationColumnV1Props> = React.memo(function (props) {
    const { order, orderItem, isSupplierShop, customizationInfos } = props;

    const unPaidOrderItem = useMemo(() => {
        if (orderItem?.customizationInfo?.type !== CustomizationInfoType.H5 && orderItem?.customizationInfo?.content) {
            return false;
        } else {
            return orderItem?.customizationInfo?.customizationFeePaid === false;
        }
    }, [orderItem]);

    if (unPaidOrderItem) {
        return (
            <div className="customization-info-container">
                <p className="mb5">定制图：</p>

                <CustomizationInfoUnpaid shopId={order.shopId} isSupplierShop={isSupplierShop} />
            </div>
        );
    }

    return (
        <div className="customization-info-container">
            {customizationInfos?.length ? <p className="mb5">定制图：</p> : null}

            {customizationInfos?.map((info, index) => {
                return <CustomizationInfo info={info} key={index} />;
            })}

            {customizationInfos?.length ? (
                <AutoLoadingButton
                    type="link"
                    className="fs12"
                    onClick={async () => {
                        await syncCustomizationInfoToSupplier({
                            retailerOrderId: order.id,
                            retailerShopId: order.shopId,
                        });

                        message.success("同步成功");
                    }}
                >
                    同步定制图
                </AutoLoadingButton>
            ) : null}
        </div>
    );
});

export default CustomizationColumnV1;
